import React from "react";
import { Navigate } from "react-router-dom";
const PublicRoutes = ({ isAuth, redirectPath = "/sports", children }) => {
  if (isAuth) {
    return <Navigate to={redirectPath} replace />;
  }
  return children;
};
export default PublicRoutes;
